import { render, staticRenderFns } from "./sio.vue?vue&type=template&id=20d22fc8&scoped=true&"
import script from "./sio.vue?vue&type=script&lang=js&"
export * from "./sio.vue?vue&type=script&lang=js&"
import style0 from "./sio.vue?vue&type=style&index=0&id=20d22fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d22fc8",
  null
  
)

export default component.exports